export function maskEmail(email: string | null | undefined, visibleStart: number = 3): string {
    if (!email || typeof email !== 'string') return '';

    const trimmed = email.trim();
    if (!trimmed) return '';

    const atIndex = trimmed.indexOf('@');
    if (atIndex <= 0) return trimmed;

    const localPart = trimmed.substring(0, atIndex);
    const domain = trimmed.substring(atIndex);

    if (localPart.length <= visibleStart) {
        return localPart.charAt(0) + '*'.repeat(Math.max(1, localPart.length - 1)) + domain;
    }

    const visible = localPart.substring(0, visibleStart);
    const masked = '*'.repeat(Math.max(1, localPart.length - visibleStart));

    return visible + masked + domain;
}

export function maskMobile(mobile: string | null | undefined, maskLastDigits: number = 4): string {
    if (!mobile || typeof mobile !== 'string') return '';

    const trimmed = mobile.trim();
    if (!trimmed) return '';

    const hasPlus = trimmed.startsWith('+');
    const digitsOnly = trimmed.replace(/[^0-9]/g, '');

    if (digitsOnly.length <= maskLastDigits) {
        return (hasPlus ? '+' : '') + digitsOnly.charAt(0) + '*'.repeat(Math.max(1, digitsOnly.length - 1));
    }

    const visiblePart = digitsOnly.substring(0, digitsOnly.length - maskLastDigits);
    const masked = '*'.repeat(maskLastDigits);

    return (hasPlus ? '+' : '') + visiblePart + masked;
}

export function maskContact(contact: string | null | undefined): string {
    if (!contact || typeof contact !== 'string') return '';

    const trimmed = contact.trim();
    if (!trimmed) return '';

    if (trimmed.includes('@')) {
        return maskEmail(trimmed);
    }

    return maskMobile(trimmed);
}
